var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEhIconMyHealth = function SvgEhIconMyHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.751 11.455-1.723 3.379c-.211.41-.845.41-1.02 0L9.003 10.5l-1.056 2.457H4.5l6.191 6.21a1.15 1.15 0 0 0 1.618 0l6.191-6.21h-3.975zm5.025-6.793c-1.898-1.76-4.816-1.46-6.573.487l-.703.75-.703-.75C9.04 3.202 6.122 2.902 4.224 4.662c-2.038 1.873-2.25 5.056-.738 7.228h3.69l1.266-3.22c.21-.488.844-.488 1.055-.038l2.038 4.868 1.722-3.67a.554.554 0 0 1 1.02 0l.949 2.06h4.288c1.511-2.172 1.3-5.355-.738-7.228"
  })));
};
export default SvgEhIconMyHealth;